// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PInfoOutlinedSvg from "@fishx/icons-svg/es/asn/PInfoOutlined";
import FishxIcon from '../components/FishxIcon';

var PInfoOutlined = function PInfoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PInfoOutlinedSvg
  }));
};

PInfoOutlined.displayName = 'PInfoOutlined';
export default React.forwardRef(PInfoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PInfoOutlined.js
// module id = 3459
// module chunks = 0